<template>
    <div class="view profile block">

    </div>
</template>
<script>

export default {
    data () {
        return {
        }
    },
    components: {
    },
    created () {
    }
}
</script>

<style lang="scss">
.profile {
}
</style>
